function AddButtonIcon(props: any) {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M24.3 12.15C24.3 12.932 23.6744 13.558 22.892 13.558H13.558V22.892C13.558 23.674 12.9324 24.3 12.15 24.3C11.368 24.3 10.742 23.6744 10.742 22.892V13.558H1.40801C0.625982 13.558 0 12.9324 0 12.15C0 11.368 0.625628 10.742 1.40801 10.742H10.742V1.40801C10.742 0.625984 11.3676 0 12.15 0C12.932 0 13.558 0.62563 13.558 1.40801V10.742H22.892C23.6744 10.742 24.3 11.368 24.3 12.15Z"
                fill="current"
            />
        </svg>
    );
}

export default AddButtonIcon;
